const mutations = {
  SET_SELECTED_DATA_FROM_SPED(state, selectedDataFromSped) {
    state.notesFromDB = selectedDataFromSped;
  },
  SET_EXPANDED_NOTE({ notesFromDB }, { idNfe }) {
    notesFromDB.tBody.forEach((item) => {
      if (item.idNfe !== idNfe && item.expanded) item.expanded = false;
      if (item.idNfe !== idNfe) return;
      item.expanded = !item.expanded;
    });
  },
  SET_ITENS_FROM_SPED(state, seletedItensFromSPED) {
    const isOnState = state.itensFromSPED.find(
      (item) => item.idNf === seletedItensFromSPED.idNf,
    );
    if (isOnState) return;
    state.itensFromSPED.push(seletedItensFromSPED);
  },
  SET_ITENS_FROM_XML(state, seletedItensFromXML) {
    const isOnState = state.itensFromXML.find(
      (item) => item.idNf === seletedItensFromXML.idNf,
    );
    if (isOnState) return;
    state.itensFromXML.push(seletedItensFromXML);
  },
  REMOVE_REFERENCE({ itensFromXML }, itemInfo) {
    const { idNfe, cProd, descricao, cest } = itemInfo;
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const itens = tBody.filter((item) => item.cProd === cProd);
    const cells = itens.flatMap((item) => item.cells);

    itens.forEach((item) => {
      item.descrCest = descricao;
      item.cest = cest;
      item.referenced = !item.referenced;
      if (!item.referenced) {
        item.vlPobApured = 0;
        item.vlStApured = 0;
      }
    });

    cells.forEach((cell) => {
      if (!["vlStIcms", "vlPobIcms", "reference"].includes(cell.name)) return;
      if (["vlStIcms", "vlPobIcms"].includes(cell.name)) {
        cell.value = 0;
        return;
      }
      cell.value = !cell.value;
    });
  },
  SET_ITEM_TO_REFERENCING({ itensFromXML }, { idNfe, cProd }) {
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const items = tBody.filter((item) => item.cProd === cProd);
    items.forEach((item) => {
      item.isReferencing = !item.isReferencing;
    });
  },
  SET_VL_APURATION_ON_ITEMS({ itensFromXML }, { idNfe, apuration }) {
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const apurationObj = {};
    apuration.forEach((item) => {
      apurationObj[item.idItem] = {
        vlIcmsDar: item.vlIcmsDar,
        vlPobreza: item.vlPobreza,
      };
    });

    tBody.forEach((item) => {
      if (!apurationObj.hasOwnProperty(item.idItem)) return;
      const { vlIcmsDar, vlPobreza } = apurationObj[item.idItem];
      item.vlStApured = vlIcmsDar;
      item.vlPobApured = vlPobreza;
      item.cells.forEach((cell) => {
        if (cell.name === "vlStIcms") cell.value = vlIcmsDar;
        if (cell.name === "vlPobIcms") cell.value = vlPobreza;
      });
    });
  },
  SET_VL_APURATION_ON_NF({ notesFromDB }, { idNfe, totalNote }) {
    const [{ cells }] = notesFromDB.tBody.filter(
      (item) => item.idNfe === idNfe,
    );
    cells.forEach((item) => {
      if (item.name === "stApurado") item.value = totalNote.vlIcmsDar;
      if (item.name === "pobApurado") item.value = totalNote.vlPobreza;
    });
  },
  SET_NOTE_TO_CALCULATING({ notesFromDB, itensFromXML }, { idNfe, cProd }) {
    const [note] = notesFromDB.tBody.filter((item) => item.idNfe === idNfe);
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const calculatingItems = tBody.filter((item) => item.cProd === cProd);
    calculatingItems.forEach((item) => {
      item.isCalculating = !item.isCalculating;
    });
    note.isCalculating = !note.isCalculating;
  },
};

export default mutations;
